var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconReset = function SvgIconReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.077 17.696A8.98 8.98 0 1 0 5.669 5.65l-.012.011.757.757a.5.5 0 0 1-.224.837l-2.898.779a.5.5 0 0 1-.615-.615l.78-2.898a.5.5 0 0 1 .836-.224l.657.658.012-.012A9.98 9.98 0 1 1 3.237 16.74a.5.5 0 1 1 .88-.475q.409.758.96 1.43"
  })));
};
export default SvgIconReset;